const firebaseConfig = {
    apiKey: "AIzaSyCSnHKmpqFXsLWgpjLVCqNY9VBDkNWrw3E",
    authDomain: "tangail-district-park.firebaseapp.com",
    projectId: "tangail-district-park",
    storageBucket: "tangail-district-park.appspot.com",
    messagingSenderId: "254146763130",
    appId: "1:254146763130:web:88d735fa661f1b5d31dec3"
};
export default firebaseConfig;